import React, { useEffect, useState } from 'react';
import './settings.scss';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { getSettingsData } from '../reducer';
import {
  loadPresets, deletePreset, loadViolationList, loadPresetsCollage,
} from '../actions';
import { getResponseError, responseLogWithNotification, useUpdatePeriod } from '../../../utils/utils';
import { getSystemData } from '../../System/reducer';
import Loader from '../../../components/base/Loader/Loader';
import PresetsForm from './PresetsForm';
import CheckBoxInputWithLabel from '../../../components/fields/CheckBoxInput/CheckBoxInputWithLabel';
import { showGlobalConfirm } from '../../System/actions';
import notificationDecorator, {
  errorNotification,
  successNotification,
} from '../../Notifications/notificationDecorator';

export default function PresetsSettingsColumns() {
  const [selectedPreset, setSelectedPreset] = useState(null);
  const [isShowForm, setIsShowForm] = useState(false);
  const [src, setSrc] = useState(null);
  const [key, setKey] = useState(0);
  const dispatch = useDispatch();
  const intl = useIntl();
  const { formatMessage } = intl;
  const {
    loadingPresetsList,
    presetsList = [],
    loadingViolationList,
    loadingSavePreset,
    loadingAddPreset,
    loadingDeletePreset,
    loadingDefaultCollage,
    violationList = [],
  } = useSelector(getSettingsData);
  const { updatePeriod } = useSelector(getSystemData);
  useEffect(() => {
    setSrc(null);
    const selectedItem = presetsList.find(item => item.id === selectedPreset);
    if (selectedItem && selectedItem.collage_settings) {
      dispatch(loadPresetsCollage(selectedItem.collage_settings))
        .then(data => {
          setSrc(data);
        })
        .catch(response => {
          errorNotification(formatMessage({ id: 'collage.create' }), getResponseError(response));
        });
    }
  }, [selectedPreset]);

  const loadData = () => {
    const p1 = dispatch(loadPresets()).catch(responseLogWithNotification);
    const p2 = dispatch(loadViolationList()).catch(responseLogWithNotification);
    return Promise.all([p1, p2]);
  };
  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);

  const handleCreate = () => {
    setSelectedPreset(null);
    setIsShowForm(true);
    setKey(key + 1);
  };

  const cancel = () => {
    setIsShowForm(false);
  };
  const handleDelete = item => event => {
    dispatch(showGlobalConfirm({
      confirmMessage: formatMessage({ id: 'app.delete.message' }, { name: item.name }),
      confirmButtonText: formatMessage({ id: 'app.delete' }),
      confirmClassName: 'remove-preset',
    })).then(() => {
      dispatch(deletePreset(item.id)).then(() => {
        loadData();
        successNotification(formatMessage({ id: 'preset.delete.title' }), formatMessage({ id: 'preset.delete.success' }));
      }).catch(response => {
        errorNotification(formatMessage({ id: 'preset.delete.title' }), getResponseError(response));
      });
    }).catch(() => {});

    event.preventDefault();
    event.stopPropagation();
    return false;
  };

  const handleEdit = item => event => {
    setSelectedPreset(item.id);
    setIsShowForm(true);
    setKey(key + 1);
    event.preventDefault();
    event.stopPropagation();
    return false;
  };
  const selectMenuItem = item => () => {
    setIsShowForm(false);
    if (selectedPreset === item.id) {
      setSelectedPreset(null);
      return;
    }
    setSelectedPreset(item.id);
  };
  const selectedItem = presetsList.find(item => item.id === selectedPreset);
  const selectedViolation = violationList && violationList.length && selectedItem ? violationList.find(item => item.id === selectedItem.violation_type_id) : null;
  return (
    <>
      <div className="settings-category frame">
        <Loader loading={loadingPresetsList || loadingViolationList || loadingSavePreset || loadingAddPreset || loadingDeletePreset || loadingDefaultCollage} />
        <div className="settings-header">
          <div className="settings-label">{formatMessage({ id: 'presets' })}</div>
          <div className="settings-buttons">
            <Button variant="secondary" onClick={handleCreate}><Icons customIcon icon="plus" /> {formatMessage({ id: 'app.create' })}</Button>
          </div>
        </div>
        <div className="settings-list-wrapper">
          <div className="settings-list custom-scroll-theme">
            {presetsList.map((item, key) => (
              <div
                key={key}
                onClick={selectMenuItem(item)}
                className={classNames('settings-menu-item', { selected: selectedPreset === item.id })}
              >
                {item.name}
                <div className="edit-and-delete-buttons">
                  <div className="menu-item-button" onClick={handleEdit(item)}><Icons customIcon icon="pencil" width={16} height={16} /></div>
                  <div className="menu-item-button" onClick={handleDelete(item)}><Icons customIcon icon="trash" width={16} height={16} /></div>
                </div>
              </div>
            ))}
            {!presetsList.length ? <div className="empty-list"><div className="empty-list-text">{formatMessage({ id: 'presets.not.found' })}</div></div> : null}
          </div>
        </div>
      </div>
      <div className="settings-options frame">
        <div className="settings-edit">
          <div className="settings-header">
            <div className="settings-label">{formatMessage({ id: 'presets.settings' })}</div>
          </div>
          {!selectedItem && !isShowForm ? (
            <div className="settings-form empty-list">
              <div className="empty-list-text">{formatMessage({ id: 'presets.settings.after.create' })}</div>
            </div>
          ) : null}
          {isShowForm ? <PresetsForm key={key} data={selectedItem} cancel={cancel} loadData={loadData} /> : null}
          {selectedItem && !isShowForm
            ? (
              <>
                <div className="settings-form">
                  <div className="settings-view-form preset-option">
                    <div className="settings-view-row">
                      <div className="settings-view-label">{formatMessage({ id: 'preset.name' })}:</div>
                      <div className="settings-view-value">{selectedItem.name || ''}</div>
                    </div>
                    <div className="settings-view-row">
                      <div className="settings-view-label">{formatMessage({ id: 'preset.start' })}:</div>
                      <div className="settings-view-value">{selectedItem.start || ''}</div>
                    </div>
                    <div className="settings-view-row">
                      <div className="settings-view-label">{formatMessage({ id: 'preset.end' })}:</div>
                      <div className="settings-view-value">{selectedItem.end || ''}</div>
                    </div>
                    <div className="settings-view-row">
                      <div className="settings-view-label">{formatMessage({ id: 'preset.interval' })}:</div>
                      <div className="settings-view-value">{formatMessage({ id: 'minute.option' }, { min: selectedItem.interval || '' })}</div>
                    </div>
                    <CheckBoxInputWithLabel
                      variant="material"
                      label={formatMessage({ id: 'preset.save_intermediate' })}
                      inputProps={{
                        value: selectedItem.save_intermediate,
                        onChange: () => {
                        },
                      }}
                      className="mt-3"
                      disabled
                    />
                    <CheckBoxInputWithLabel
                      variant="material"
                      label={formatMessage({ id: 'preset.show_intermediate' })}
                      inputProps={{
                        value: selectedItem.show_intermediate,
                        onChange: () => {
                        },
                      }}
                      className="mt-3"
                      disabled
                    />

                    <div className="f4 mt-3 mb-3">{formatMessage({ id: 'select.days' })}</div>
                    <table className="days-table">
                      <tbody>
                        <tr>
                          <td><CheckBoxInputWithLabel inputProps={{ value: selectedItem.days.all, onChange: () => {} }} variant="material" label={formatMessage({ id: 'days.all' })} disabled /></td>
                          <td><CheckBoxInputWithLabel inputProps={{ value: selectedItem.days.even, onChange: () => {} }} variant="material" label={formatMessage({ id: 'days.even' })} disabled /></td>
                          <td><CheckBoxInputWithLabel inputProps={{ value: selectedItem.days.working, onChange: () => {} }} variant="material" label={formatMessage({ id: 'days.working' })} disabled /></td>
                          <td><CheckBoxInputWithLabel inputProps={{ value: selectedItem.days.saturday, onChange: () => {} }} variant="material" label={formatMessage({ id: 'days.saturday' })} disabled /></td>
                        </tr>
                        <tr>
                          <td />
                          <td><CheckBoxInputWithLabel inputProps={{ value: selectedItem.days.odd, onChange: () => {} }} className="mt-3" variant="material" label={formatMessage({ id: 'days.odd' })} disabled /></td>
                          <td>
                            <CheckBoxInputWithLabel inputProps={{ value: selectedItem.days.holidays, onChange: () => {} }} className="mt-3" variant="material" label={formatMessage({ id: 'days.holidays' })} disabled />
                          </td>
                          <td><CheckBoxInputWithLabel inputProps={{ value: selectedItem.days.sunday, onChange: () => {} }} className="mt-3" variant="material" label={formatMessage({ id: 'days.sunday' })} disabled />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div className="settings-view-row">
                      <div className="settings-view-label">{formatMessage({ id: 'preset.violation_type_id' })}:</div>
                      <div className="settings-view-value">{selectedViolation ? selectedViolation.code_description : ''}</div>
                    </div>
                    <div className="preset-collage-data mt-3">
                      <div className="settings-view-row">
                        <div className="settings-view-label">{formatMessage({ id: 'collage' })}:</div>
                        {/* <div className="settings-view-value collage-ie-row"> */}
                        {/*  <div className="cl-button"> */}
                        {/*    <Icons customIcon icon="file-export" width={24} height={24} /> */}
                        {/*  </div> */}
                        {/*  <div className="cl-button"> */}
                        {/*    <Icons customIcon icon="file-import" width={24} height={24} /> */}
                        {/*  </div> */}
                        {/* </div> */}
                      </div>
                      <div className="settings-view-row">
                        <div className="settings-view-value collage-image-row">
                          {src ? <img className="collage-image" src={URL.createObjectURL(src)} alt="img" /> : null }
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <div className="settings-footer">
                  <Button className="clear-show" onClick={handleEdit(selectedItem)}>{formatMessage({ id: 'app.edit' })}</Button>
                  <Button
                    className="clear-data"
                    variant="secondary"
                    onClick={handleDelete(selectedItem)}
                  >{formatMessage({ id: 'app.delete' })}
                  </Button>
                </div>
              </>
            ) : null}

        </div>
      </div>
    </>
  );
}
